__webpack_require__.p = "/jackpot-promo/";